import MuiCard from '@mui/material/Card';
import { SvgIconProps as IMuiSvgIconProps } from '@mui/material/SvgIcon';
import { IComponentCss } from '@tap/mui-ui';
import { Grid2, Typography, CardContent } from '@mui/material';
import { Link } from 'react-router';
import { ReactElement } from 'react';

/**
 *   Карточка
 */

export type IActionCard = {
    /** Заголовок */
    title: string,

    /** Описание */
    description?: string,

    /** Картинка */
    img: IMuiSvgIconProps | any,

    /** Ссылка на страницу */
    link: string,

    /** Источник данных (нужен для чекера/проверки, есть ли данные) */
    dataSource?: string,

    /** Признак - есть / нет данных */
    isHasData?: boolean,

    features?: string[],
}


const css: IComponentCss = {
    cardWrap: {
        height: '100%',
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    card: {
        height: '100%',
        borderColor: 'white',
        textDecoration: 'none !important',
    },
    noDataBadge: {
        position: 'absolute',
        padding: '5px',
        top: '0px',
        right: '0px',
        fontSize: '0.8125em',
        backgroundColor: '#BFBFBF',
        color: '#FFFFFF',
        borderRadius: '0px 4px 0px 4px',
    },
    imgWrap: {
        height: '120px',
        border: '1.5px solid #E0E0E0',
        borderRadius: '3px',
        paddingTop: '10px',
        textAlign: 'center',
        marginTop: '10px',
        marginBottom: '20px',
        '& .MuiSvgIcon-root': {
            fontSize: '100px',
        },
    },
    title: {
        lineHeight: 1.4,
        marginBottom: '10px',
    },
};


export function ActionCard({
    title,
    description,
    img,
    link,
    isHasData = true,
}: IActionCard): ReactElement {
    return (
        <Grid2 size={{ xs: 12, sm: 6, md: 3 }}
        >
            <Grid2 sx={{ ...css.cardWrap }}>
                {/* Бейдж - нет данных */}
                {isHasData === false && <Grid sx={css.noDataBadge}>Нет данных</Grid>}

                <MuiCard
                    sx={{
                        cursor: isHasData ? 'pointer' : 'default',
                        backgroundColor: isHasData ? '' : '#F7F7F7',
                        ...css.card,
                    }}
                    variant="outlined"
                    to={link}
                    component={isHasData ? Link : Grid}
                >
                    <CardContent>
                        <Grid2
                            sx={{
                                color: isHasData ? '' : '#666666',
                                ...css.imgWrap,
                            }}
                        >
                            {img}
                        </Grid2>
                        <Typography
                            sx={{
                                color: isHasData ? '' : '#666666',
                                ...css.title,
                            }}
                            variant='h6'
                            color="text.primary"
                            gutterBottom
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant='body1'
                            color="text.secondary"
                        >
                            {!!description && description}
                        </Typography>
                    </CardContent>
                </MuiCard>
            </Grid2>
        </Grid2>
    );
}